import {styled} from '@mui/material';

import {AccordionData, AlertInfo} from 'presentation/components';

const DrawerAlertInfo = styled(AlertInfo.Root)(() => ({
	marginTop: '24px',
}));

const ChargeDetailsAccordion = styled(AccordionData)(({theme}) => ({
	marginTop: theme.spacing(3),
	border: `1px solid ${theme.palette.other.divider}`,
	'&::before': {display: 'none'},
}));

export {DrawerAlertInfo, ChargeDetailsAccordion};
